SearchVilla =  {

	list : false

	init : ->
		console.log 'SearchVilla init'

		@listInit()
		@revealSearch()
		@mapManager()
		@regionsManager()

	listInit : ->
		options = {
			valueNames: [
				{ data: ['region'] }
			]
		}

		@list = new List('liste-residences', options);

		# @list.on "filterStart",  ->

	revealSearch : ->
		$('.search-villa--type .type--content').on "mouseenter", (ev) ->
			parentElt = $(@).parents('.search-villa--type')
			descElt = parentElt.find('.type--desc')

			tlShowFilter = new TimelineLite
			tlShowFilter.to(@, 0.3, {y:'-65%', autoAlpha:0, ease:Quad.easeInOut})
			if parentElt.hasClass('search-villa--region')
				tlShowFilter.set(descElt, {autoAlpha:1})
					.staggerFromTo(descElt.find('.region'), 0.3, {y:30, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quad.easeInOut}, 0.05)
					.add ->
						parentElt.addClass('active')
			else
				tlShowFilter.fromTo(descElt, 0.3, {scale:0.97, autoAlpha:0}, {scale:1, autoAlpha:1, ease:Quad.easeInOut, force3D:true})
				tlShowFilter.add ->
					parentElt.addClass('active')


		$('.search-villa--type').on "mouseleave", (ev) ->

			if $(@).hasClass('active')
				
				_this = @
				descElt = $(@).find('.type--desc')
				contentElt = $(@).find('.type--content')

				if $(@).hasClass('search-villa--region')
					tlCloseRegions = new TimelineLite
					tlCloseRegions.staggerTo($(@).find('.region'), 0.3, {y:-30, autoAlpha:0, force3D:true}, 0.05)
						.set(descElt, {autoAlpha:0})
						.fromTo(contentElt, 0.3, {y:'-45%', autoAlpha:0}, {y:'-50%', autoAlpha:1, ease:Quad.easeInOut})
						.add ->
							$(_this).removeClass('active')
				else
					tlCloseMap = new TimelineLite
					tlCloseMap.to(descElt, 0.3, {scale:0.97, autoAlpha:0, ease:Quad.easeInOut})
						.fromTo(contentElt, 0.3, {y:'-35%', autoAlpha:0}, {y:'-50%', autoAlpha:1, ease:Quad.easeInOut})
						.add ->
							$(_this).removeClass('active')
							$.each descElt.find('path, polygon'), (i, elt) ->
								TweenLite.set(elt, {fill: $(elt).attr('fill-save')})

	mapManager : ->

		_this = @

		mapSvg = $('.search-villa--carte .type--desc svg')

		mapSvg.find('path, polygon').on "mouseenter", (ev) ->
			
			# Reset other regions bck color
			$.each mapSvg.find('path, polygon'), (i, elt) ->
				TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			

			# Change selected region bck color
			if $(@).hasClass('has-villas')
				TweenLite.to(@, 0.3, {fill: '#FEBF3E'})

		# Filter villas list on click
		mapSvg.find('path, polygon').on "click", (ev) ->
			if $(@).hasClass('selected')
				$(@).removeClass('selected')
				_this.list.filter()

			else
				# remove selected class on regions map
				mapSvg.find('path, polygon').removeClass('selected')
				# remove selected class on regions list
				$('.search-villa--region .region').removeClass('selected')
				# add selected class on clicked element
				$(@).addClass('selected')
				# filter by selected region
				region = $(@).attr('id')
				_this.filterList(region)

	regionsManager : ->

		_this = @

		$('.search-villa--region .region').on "click", (ev) ->
			console.log("SEARCH REGION")
			if $(@).hasClass('selected')
				$(@).removeClass('selected')
				_this.list.filter()	
			else
				# remove selected class on regions map
				mapSvg = $('.search-villa--carte .type--desc svg')
				mapSvg.find('path, polygon').removeClass('selected')
				# remove selected class on regions list
				$('.search-villa--region .region').removeClass('selected')
				# add selected class on clicked element
				$(@).addClass('selected')
				# filter by selected region
				region = $(@).attr('data-filter')
				_this.filterList(region)

		$('.block-search-villa .cta_down').on "click", (ev) ->
			console.log("FILTER REGION")
			_this.list.filter()	

	filterList : (region) ->
		console.log region
		@list.filter (item) ->
			if item.values().region == region
				return true
			else
				return false
		
		# Smooth scroll to villas list
		TweenLite.to(window, 1, { scrollTo: {y: '#liste-residences'}, ease:Quint.easeInOut })



	destroy : ->
		console.log "SearchVilla destroy"
		
}